var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675.25 603.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#155d77;}.cls-2{fill:#25a8ba;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Planning Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.53,842.31v-94.9l579.47.26s95.77.26,95.77,94.64Z",
    transform: "translate(-202.53 -238.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.53,672.71v-94.9l436.23.26s94.38.26,94.38,94.64Z",
    transform: "translate(-202.53 -238.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.53,503.1V408.21H484.62S579,408.73,579,503.1Z",
    transform: "translate(-202.53 -238.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.53,333.5V238.6H347.77s94.37.52,94.37,94.9Z",
    transform: "translate(-202.53 -238.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.ab07ba8459c229a9f2a7fca6d0d9e547.svg";
export { ForwardRef as ReactComponent };